// src/components/MainContent.jsx
// 1:1 aus dem CRM übernommen.
import React from 'react';

function MainContent({ children }) {
  return <main className="main-content">{children}</main>;
}

export default MainContent;
